"use client";

import { createContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import io from "socket.io-client";
import useLogin from "../hooks/useLogin";
import useSession from "../hooks/useSession";
import { connect } from "react-redux";

export const SocketContext = createContext();

const SocketProvider = ({ children, idUser }) => {
  const { refreshToken } = useLogin();
  const { saveTimeLeft } = useSession();
  const [timeLeft, setTimeLeft] = useState(0);
  const socketRef = useRef(null);
  const navigate = useNavigate();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const jwt = localStorage.getItem("token");

  const isExpired = localStorage.getItem("sessionExpired");

  const reGenerateToken = async (token) => {
    try {
      setIsRefreshing(true);
      await refreshToken(token);
      setTimeLeft(300); // Reset countdown after refresh
    } catch (error) {
      console.log("errore", error);
    } finally {
      setIsRefreshing(false);
    }
  };

  useEffect(() => {
    const jwt = localStorage.getItem("token");

    const socket = io(process.env.REACT_APP_API_URL, {
      transportOptions: {
        polling: {
          extraHeaders: {
            authorization: `Bearer ${jwt}`,
          },
        },
      },
    });

    socketRef.current = socket;

    socket.emit("web:connection");

    socket.on("web:connection", () => {
      localStorage.removeItem("sessionExpired");
    });

    socket.on("web:sessionexpired", () => {
      localStorage.removeItem("token");
      localStorage.setItem("sessionExpired", "true");
      window.location.reload();
    });

    socket.on(`web:tokenSessionUsed-${idUser}`, (data) => {
      if (jwt && !isExpired && !data.token) {
        reGenerateToken();
      } else if (data.token) {
        reGenerateToken(data.token);
        setTimeLeft(300); // Set countdown to 5 minutes
      }
    });

    return () => {
      socket.off("web:connection");
      socket.disconnect();
    };
  }, [idUser]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (isRefreshing) {
        return;
      }
      setTimeLeft((prevTime) => {
        const updatedTime = (prevTime || 1) - 1;

        if (updatedTime <= 0) {
          jwt && reGenerateToken();
        }

        saveTimeLeft(updatedTime);
        return updatedTime;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isRefreshing]);

  return (
    <SocketContext.Provider value={{ socket: socketRef.current, timeLeft }}>
      {children}
    </SocketContext.Provider>
  );
};

const mapStateToProps = (state) => {
  return {
    idUser: state.usersReducer.userLogged.idUser,
  };
};

export default connect(mapStateToProps, null)(SocketProvider);
